import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertMessageIcon from "@tCentro/Icons/AlertMessageIcon";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: NISProductAlertMessageStyles;
    alertMessage?: string;
}

type Props = OwnProps;

export interface NISProductAlertMessageStyles {
    alertMessage?: TypographyProps;
    alertMessageIcon?: InjectableCss;
}

export const nisProductAlertMessageStyles: NISProductAlertMessageStyles = {
    alertMessage: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.tiny};
            line-height: 16px;
            text-transform: capitalize;
            color: ${COLORS.alertMsgRed};
            font-family: Roboto;
        `,
    },
    alertMessageIcon: {
        css: css`
            vertical-align: middle;
        `,
    },
};

const NISProductAlertMessage: FC<Props> = ({ alertMessage }) => {
    return (
        <StyledWrapper>
            <StyledWrapper {...nisProductAlertMessageStyles.alertMessage}>
                <Icon src={AlertMessageIcon} {...nisProductAlertMessageStyles.alertMessageIcon} />
                {alertMessage}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default NISProductAlertMessage;
